// extracted by mini-css-extract-plugin
module.exports = {"img":"MainScene_img__Ukb_v"};